import React, { useContext } from "react";
import { checkSlaTime } from "../../services/provider/common";
import { checkFeatureFeasbility } from "../../helper/utils";
import UserFeaturesContext from "../../hook/UserDetails/UserFeaturesContext";

const ActionsCell = ({
  applicableActions,
  currentOrder,
  setMoveToPickedDialogVisibility,
  setCartDialogVisibility,
  setBillUploadDialogVisibility,
  setOrderSummaryVisibility,
  setMoveToPickupReadyDialogVisibility,
  setViewRxDialogVisibility,
  setCurrentOrder,
  showSLA,
  rxToShowStatus,
}) => {
  const slaTime = checkSlaTime(currentOrder.modifiedOn, 4);
  const actionToPopupMap = {
    "Process Order": () => setCartDialogVisibility(true),
    "Upload Bill": () => setBillUploadDialogVisibility(true),
    "Order Summary": () => setOrderSummaryVisibility(true),
    "Pickup Ready": () => setMoveToPickupReadyDialogVisibility(true),
    "Start Production": () => setMoveToPickedDialogVisibility(true),
    "View Rx": () => setViewRxDialogVisibility(true),
  };
  const { userFeatures } = useContext(UserFeaturesContext);
  const isRescheduleFeatureEnabled = checkFeatureFeasbility("RESCHEDULE_APPOINTMENT", userFeatures);

  const handleClickAction = (action) => {
    // Call the appropriate function from the map
    actionToPopupMap[action]();
    setCurrentOrder(currentOrder);
  };

  return (
    <div>
      {applicableActions?.length ? (
        <>
          <div className="text-xs flex">
            {applicableActions.map((action) => {
              if (action === "View Rx") {
                if (
                  (rxToShowStatus?.length &&
                  !rxToShowStatus.includes(currentOrder.statusID)) || !currentOrder.uploadedFiles?.length
                ) {
                  return <></>;
                }
              }
              return (
                <button
                  className={
                    isRescheduleFeatureEnabled || ["View Rx", "Order Summary"].includes(action) ?
                    "border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-pointer ml-2 mb-2" :
                    "border border-gray-400 text-gray-900 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-default ml-2 mb-2"
                  }
                  disabled={!isRescheduleFeatureEnabled && !["View Rx", "Order Summary"].includes(action)}
                  onClick={() => handleClickAction(action)}
                >
                  {action}
                </button>
              );
            })}
          </div>
          {slaTime && showSLA && (
            <div
              className="pt-1 text-center font-normal mt-1 bg-red-100 rounded"
              style={{ fontSize: "12px" }}
            >
              <div className="animateSLACount">Action Pending Since</div>
              <div className="animateSLACount">
                {slaTime.month ? (
                  <span>{slaTime.month} Month</span>
                ) : slaTime.day ? (
                  <span>
                    {slaTime.day} Day
                    {slaTime.hour ? `s ${slaTime.hour} Hours` : ""}
                  </span>
                ) : slaTime.hour ? (
                  <span>{slaTime.hour} Hour</span>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div>No Actions Allowed</div>
      )}
    </div>
  );
};

export default ActionsCell;
